import { exists } from "i18next";

export const setToLocalStorage = (key: string, data: any) => {
    localStorage.setItem(key, JSON.stringify(data));
};
  
export const getFromLocalStorage = (key: string): any | null => {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
};
  
export  const removeFromLocalStorage = (key: string) => {
    localStorage.removeItem(key);
};


const dbName:string = "WALLET_CONNECT_V2_INDEXED_DB";
export const removeDatabaseWalletConnect = async () => {
    try{
        indexedDB.deleteDatabase(dbName);
    }catch(error){
        console.log("errore durante la cancellazione di INDEXED_DB", error)
    }
}


